import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PressReleaseForm = ({ formData, onChange, errors, isEditable = true }) => {
  const stateOptions = [
    { value: '', label: 'Select State' },
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
  ];

  const handleInputChange = (field, value) => {
    onChange(field, value);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 md:p-8 shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.1)))' }}>
          <Icon name="FileText" size={20} color="black" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">Press Release Information</h2>
          <p className="text-sm text-muted-foreground font-caption">Fill in the details to generate your press release</p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Surgeon Name"
            type="text"
            placeholder="John Smith, MD, FACS"
            value={formData?.surgeonName}
            onChange={(e) => handleInputChange('surgeonName', e?.target?.value)}
            error={errors?.surgeonName}
            required
            description="Name with credentials"
            disabled={!isEditable}
          />

          <Input
            label="Practice Name"
            type="text"
            placeholder="Advanced Surgical Center"
            value={formData?.practiceName}
            onChange={(e) => handleInputChange('practiceName', e?.target?.value)}
            error={errors?.practiceName}
            required
            description="Official practice name"
            disabled={!isEditable}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="City"
            type="text"
            placeholder="San Francisco"
            value={formData?.city}
            onChange={(e) => handleInputChange('city', e?.target?.value)}
            error={errors?.city}
            required
            disabled={!isEditable}
          />

          <Select
            label="State"
            options={stateOptions}
            value={formData?.state}
            onChange={(value) => handleInputChange('state', value)}
            error={errors?.state}
            required
            searchable
            disabled={!isEditable}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Surgeon Quote <span className="text-destructive">*</span>
          </label>
          <textarea
            className="w-full min-h-[120px] px-4 py-3 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none"
            placeholder="Enter a professional quote about offering VeraForm technology..."
            value={formData?.quote}
            onChange={(e) => handleInputChange('quote', e?.target?.value)}
            maxLength={500}
            disabled={!isEditable}
          />
          <div className="flex items-center justify-between mt-2">
            <p className="text-xs text-muted-foreground font-caption">
              {errors?.quote || 'Professional quote highlighting VeraForm benefits'}
            </p>
            <span className="text-xs text-muted-foreground font-caption">
              {formData?.quote?.length || 0}/500
            </span>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Practice Description
          </label>
          <textarea
            className="w-full min-h-[80px] px-4 py-3 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none"
            placeholder="Brief description of your practice (optional)"
            value={formData?.practiceDescription}
            onChange={(e) => handleInputChange('practiceDescription', e?.target?.value)}
            maxLength={300}
            disabled={!isEditable}
          />
          <div className="flex items-center justify-between mt-2">
            <p className="text-xs text-muted-foreground font-caption">
              Optional: Brief practice description for About section
            </p>
            <span className="text-xs text-muted-foreground font-caption">
              {formData?.practiceDescription?.length || 0}/300
            </span>
          </div>
        </div>

        <div className="border-t border-border pt-6">
          <h3 className="text-lg font-semibold text-foreground mb-4">Media Contact</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input
              label="Contact Name"
              type="text"
              placeholder="Jane Doe"
              value={formData?.contactName}
              onChange={(e) => handleInputChange('contactName', e?.target?.value)}
              error={errors?.contactName}
              required
              description="Media contact person"
              disabled={!isEditable}
            />

            <Input
              label="Contact Title"
              type="text"
              placeholder="Marketing Director"
              value={formData?.contactTitle}
              onChange={(e) => handleInputChange('contactTitle', e?.target?.value)}
              error={errors?.contactTitle}
              description="Contact person's title"
              disabled={!isEditable}
            />

            <Input
              label="Contact Phone"
              type="tel"
              placeholder="(555) 123-4567"
              value={formData?.contactPhone}
              onChange={(e) => handleInputChange('contactPhone', e?.target?.value)}
              error={errors?.contactPhone}
              required
              disabled={!isEditable}
            />

            <Input
              label="Contact Email"
              type="email"
              placeholder="media@practice.com"
              value={formData?.contactEmail}
              onChange={(e) => handleInputChange('contactEmail', e?.target?.value)}
              error={errors?.contactEmail}
              required
              disabled={!isEditable}
            />

            <Input
              label="Practice Website"
              type="url"
              placeholder="https://www.practice.com"
              value={formData?.website}
              onChange={(e) => handleInputChange('website', e?.target?.value)}
              error={errors?.website}
              description="Optional"
              disabled={!isEditable}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PressReleaseForm;